import { setStorage, storagePrefix } from "./storage";
import { STORAGE_AUTHOR_HASH, STORAGE_USER_ID, STORAGE_USER_PREF } from "../constants/localstorage";
import store from "../store";
import { clearAllRooms } from "../store/rooms/actions";
import { memoryHistory } from "../index";
import { ROUTE_LOGIN } from "../constants/routes";
import { AccountDetector } from "../constants/globals";
import { RegisteredUser } from "../proto/Global_pb";
import { UserRegisterResponse } from "../proto/UserRegister_pb";

export default class MultiAccount {
  static maxAccount: number = 3;
  static newPrefixId: number = 1;
  static currentPrefixId: number = 4;

  static async createAccount(): Promise<void> {
    await setStorage(STORAGE_USER_PREF, this.prefixDetector(AccountDetector.NEW), false, false);
    await store.dispatch(clearAllRooms());
    await memoryHistory.push(ROUTE_LOGIN);
    await window.location.reload();
  }

  static changeAccount(userId: string): void {
    setStorage(STORAGE_USER_PREF, this.getPrefixWithUserId(userId), false, false);
    window.location.reload();
  }

  static prefixDetector(detector: AccountDetector): number {
    let currentPrefix = 1,
      foundedPrefixId = this.newPrefixId;
    do {
      const key = storagePrefix + `${currentPrefix}__` + STORAGE_USER_ID;
      const thisPrefix = window.localStorage.getItem(key);
      const thisPrefixCondition = detector === AccountDetector.NEW ? !thisPrefix : thisPrefix;
      if (thisPrefixCondition) {
        foundedPrefixId = currentPrefix;
        break;
      }
      currentPrefix++;
    } while (currentPrefix <= this.maxAccount);
    return foundedPrefixId;
  }

  static createNewSession(userId: RegisteredUser.AsObject["id"], authorHash: UserRegisterResponse.AsObject["authorHash"]): void {
    if (this.prefixDetector(AccountDetector.NEW) === 1) setStorage(STORAGE_USER_PREF, this.prefixDetector(AccountDetector.NEW), false, false);
    setStorage(STORAGE_USER_ID, userId);
    setStorage(STORAGE_AUTHOR_HASH, authorHash);
    // store.dispatch(setResetReducerState);
  }

  static getPrefixWithUserId(userId?: RegisteredUser.AsObject["id"]): number | undefined {
    for (let i = 1; i <= +this.maxAccount; i++) {
      const prefix = `${i}__`;
      const storageUserId = localStorage.getItem(storagePrefix + prefix + STORAGE_USER_ID);
      if (userId === storageUserId) return i;
    }
  }

  static hasAccount(): number | undefined {
    for (let i = 1; i <= this.maxAccount; i++) {
      const prefix = `${i}__`;
      const storageUserId = localStorage.getItem(storagePrefix + prefix + STORAGE_USER_ID);
      if (storageUserId) return i;
    }
  }

  static availableAccounts(): Array<number> {
    const accounts: Array<number> = [];
    for (let i = 1; i <= this.maxAccount; i++) {
      const prefix = `${i}__`;
      const storageUserId = localStorage.getItem(storagePrefix + prefix + STORAGE_USER_ID);
      if (storageUserId) accounts.push(i);
    }
    return accounts;
  }

  static backToAccount(): void {
    setStorage(STORAGE_USER_PREF, MultiAccount.hasAccount(), false, false);
    window.location.reload();
  }
}
